import { Button } from '@ui';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { MollieConnectButton } from '../MollieConnectButton';

interface Props {
    clubSlug: string;
}

const MollieConnectTutorial = ({ clubSlug }: Props) => {
    const { t } = useTranslation('general');

    return (
        <div className="tw-space-y-4">
            <div className="tw-card">
                <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-accents-5">
                    <h4 className="tw-mb-0 tw-font-semibold">{t('mollie.tutorial.step1.title')}</h4>
                    <div className="tw-badge-light">{t('mollie.tutorial.stepBadge', { n: 1 })}</div>
                </div>
                <p>{t('mollie.tutorial.step1.description')}</p>
                <a href="https://www.mollie.com/de/pricing" target="_blank">
                    <Button color="secondary" block size="sm" className="!tw-mb-2">
                        {t('mollie.tutorial.step1.pricingButton')}
                    </Button>
                </a>
                <Link href="/kontakt">
                    <Button color="secondary" block size="sm">
                        {t('mollie.tutorial.step1.contactButton')}
                    </Button>
                </Link>
            </div>
            <div className="tw-card">
                <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-accents-5">
                    <h4 className="tw-mb-0 tw-font-semibold">{t('mollie.tutorial.step2.title')}</h4>
                    <div className="tw-badge-light">{t('mollie.tutorial.stepBadge', { n: 2 })}</div>
                </div>
                <p>{t('mollie.tutorial.step2.description')}</p>
                <a href="https://my.mollie.com/dashboard/signup?lang=de" target="_blank">
                    <Button color="secondary" block size="sm">
                        {t('mollie.common.registerButton')}
                    </Button>
                </a>
            </div>
            <div className="tw-card">
                <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-accents-5">
                    <h4 className="tw-mb-0 tw-font-semibold">{t('mollie.tutorial.step3.title')}</h4>
                    <div className="tw-badge-light">{t('mollie.tutorial.stepBadge', { n: 3 })}</div>
                </div>
                <p>{t('mollie.tutorial.step3.description')}</p>
                <div className="tw-flex tw-justify-center">
                    <MollieConnectButton clubSlug={clubSlug} />
                </div>
            </div>
        </div>
    );
};

export default MollieConnectTutorial;
